<template>
  <img src="http://yunlei-rabbit-hn2.oss-cn-heyuan.aliyuncs.com/2025/4/8/1909585940140589058.png" />
  <div class="box" style="margin-top: 30px">
    <van-form @submit="onSubmit">
      <!-- 可以使用 CellGroup 作为容器 -->
      <van-cell-group inset style="height: 42px" class="container">
        <van-field v-model="value" label="姓名" placeholder="请输入您的真实姓名 " />
      </van-cell-group>
      <van-cell-group inset style="height: 42px" class="container">
        <van-field v-model="value1" label="手机" placeholder="请输入您的联系方式 " type="digit" />
      </van-cell-group>
      <van-cell-group inset style="height: 42px" class="container">
        <van-field name="checkbox" label="店铺位置">
          <template #input>
            <van-radio-group v-model="schoolFlag" direction="horizontal">
              <van-radio name="1">校内</van-radio>
              <van-radio name="0">校外</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group inset style="height: 42px" class="container">
        <van-field v-model="value2" label="店铺名称" placeholder="请输入您的店铺名 " />
      </van-cell-group>
      <van-cell-group inset style="height: 42px" class="container">
        <van-field
          is-link
          v-model="value3"
          label="校区/站点"
          placeholder="请选择校区/站点 "
          @click="showPopup"
        ></van-field>
        <van-popup
          v-model:show="show"
          position="bottom"
          :style="{ height: '50%' }"
          close-icon-position="top-left"
          round
        >
          <van-picker
            title="选择校区/站点"
            :columns="schoolList"
            @confirm="onConfirm"
            @cancel="onCancel"
            :columns-field-names="customFieldName"
          />
        </van-popup>
      </van-cell-group>
    </van-form>
  </div>
  <div class="button" @click="join">
    <van-button type="primary" color="white" block round>
      <text style="color: skyblue; font-weight: bold; font-size: 20px">提交申请</text>
    </van-button>
  </div>
  <div class="text">申请后24小时内会有客服和您联系，请保证通讯通畅</div>
</template>

<script>
import { ref } from "vue";
import { Toast, Dialog } from "vant";
import { req } from "@/axios/http";
import { getSchoolList } from "@/api/total-point";

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  setup() {
    const value = ref("");
    const value1 = ref("");
    const value2 = ref("");
    const value3 = ref("");
    const show = ref(false);
    const schoolFlag = ref("0");
    const schoolId = ref("");
    const showPopup = () => {
      show.value = true;
    };
    // const columns = ['贵州水利水电职业技术学院', '贵州师范大学花溪校区', '贵州师范大学西校区'];
    const onCancel = () => (show.value = false);
    const customFieldName = {
      text: "name",
    };
    return {
      value,
      value1,
      value2,
      value3,
      show,
      showPopup,
      // columns,
      onCancel,
      schoolList: [],
      customFieldName,
      schoolFlag,
      schoolId,
    };
  },
  methods: {
    join() {
      var num = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (this.value == "") Toast("输入的真实姓名不能为空!!");
      else if (this.value1 == "") Toast("输入的联系方式不能为空!!");
      else if (this.value1.length != 11) Toast("输入正确的电话号码!!");
      else if (!num.test(this.value1)) Toast("输入正确的电话号码!!");
      else if (this.value2 == "") Toast("输入的店铺名不能为空!!");
      else if (this.value3 == "") Toast("请选择校区/站点");
      else
        req
          .post({
            url: "/app/rabbit/merchant/merchantEnter/add",
            data: {
              name: this.value,
              phone: this.value1,
              shopName: this.value2,
              schoolId: this.schoolId,
              schoolFlag: Boolean(Number(this.schoolFlag)),
            },
          })
          .then((res) => {
            console.log(res);
            Dialog.alert({
              title: "申请成功",
              message: "24小时内会有客服和您联系，请保持通讯通畅",
              theme: "round-button",
              confirmButtonColor: "#00c4ff",
            }).then(() => {
              this.value = "";
              this.value1 = "";
              this.value2 = "";
              this.value3 = "";
            });
          });
    },
    onConfirm(value) {
      this.value3 = value.name;
      this.schoolId = value.id;
      this.show = false;
    },
  },
  created() {
    document.title = "入驻";
    getSchoolList({ current: 1, size: 1000 }).then((res) => {
      console.log(res);
      if (res.code === 200) {
        this.schoolList = res.data.records;
      }
    });
  },
};
</script>

<style scoped>
img {
  width: 100%;
}

.container {
  margin: 25px 15px;
  font-size: 20px;
}

label {
  font-weight: bold;
  color: black;
  font-size: 35px;
}

.button {
  width: 80%;
  margin: 40px auto;
}

.text {
  text-align: center;
  font-size: 28px;
}
</style>
